<template>
    <div>
        <div class="w-full flex flex-col lg:justify-between py-4 border-b border-gray-300">
            {{ $t('email_settings') }}
            <p class="mt-2">
                {{ $t('email_settings_description') }}
            </p>
        </div>

        <div class="my-8">
            <Loading :loading="loading" :preserveHeight="true">
                <div v-if="!loading">
                    <SectionWrapper borderPosition="bottom">
                        <template #title>
                            {{ $t('plain_general') }}
                        </template>

                        <template #content>
                            <div class="flex flex-row gap-6 items-center">
                                <SingleToggle
                                    :active="user.meta.notifications.newsletters"
                                    @update:active="user.meta.notifications.newsletters = !user.meta.notifications.newsletters"
                                    backgroundColor="#031837"
                                    backgroundGradient="#031837"
                                />
                                <p>
                                    {{ $t('plain_newsletter') }}
                                </p>
                            </div>

                            <div class="flex flex-row gap-6 items-center">
                                <SingleToggle
                                    :active="user.meta.notifications.contentstreams"
                                    @update:active="user.meta.notifications.contentstreams = !user.meta.notifications.contentstreams"
                                    backgroundColor="#031837"
                                    backgroundGradient="#031837"
                                />
                                <p>
                                    {{ $t('subscription_updates') }}
                                </p>
                            </div>

                            <div class="flex flex-row gap-6 items-center">
                                <SingleToggle
                                    :active="user.meta.notifications.actionsAndEvents"
                                    @update:active="user.meta.notifications.actionsAndEvents = !user.meta.notifications.actionsAndEvents"
                                    backgroundColor="#031837"
                                    backgroundGradient="#031837"
                                />
                                <p>{{ $t('actionsAndEvents') }}</p>
                            </div>
                        </template>
                    </SectionWrapper>
                    <TransitionExpand v-show="user.meta.notifications.contentstreams">
                        <SectionWrapper borderPosition="bottom" v-if="abonnements.data.length">
                            <template #title>
                                {{ $t('plain_abonnements') }}
                            </template>

                            <template #content>
                                <div v-for="abonnement in abonnements.data" :key="abonnement.id" class="flex flex-row gap-6 items-center">
                                    <SingleToggle
                                        :active="abonnement.meta.notifications"
                                        @update:active="handleToggle(abonnement)"
                                        backgroundColor="#031837"
                                        backgroundGradient="#031837"
                                    />
                                    <p>
                                        {{ $translate(abonnement.product.name) }}
                                    </p>
                                </div>
                            </template>
                        </SectionWrapper>
                    </TransitionExpand>
                </div>
            </Loading>

            <div class="flex justify-end">
                <FormButton class="mt-6 w-auto" @click="update()" :formComponentId="this.$.uid" styling="primary" :value="$t('plain_update')" :disabled="loading"> </FormButton>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import i18next from 'i18next';

export default {
    data: () => ({
        loading: true,
        allNotifications: true,
        idsToUpdate: []
    }),
    mounted() {
        this.loading = true;

        let promisses = [];

        promisses.push(this.$store.dispatch('user/user'));

        promisses.push(
            this.$store.dispatch('abonnements/index', {
                params: {
                    'sort[by]': 'created_at',
                    per_page: 100,
                    webinar: false,
                    current: true
                }
            })
        );

        Promise.all(promisses).then(() => {
            this.abonnements.data.sort((a, b) => {
                return a.product.name.de.localeCompare(b.product.name.de);
            });

            this.loading = false;
        });
    },
    computed: {
        ...mapGetters('user', {
            user: 'get'
        }),
        ...mapGetters('abonnements', {
            abonnements: 'get'
        })
    },
    methods: {
        //method to add ids of changed abonnements to idsToUpdate without duplicats and toggle the notifications as needed
        handleToggle(abonnement) {
            let id = abonnement.id;
            if (abonnement.meta && typeof abonnement.meta.notifications === 'boolean') {
                if (id && !this.idsToUpdate.includes(id)) {
                    this.idsToUpdate.push(id);
                }
                abonnement.meta.notifications = !abonnement.meta.notifications;
            } else {
                console.warn('Abonnement meta oder notifications ist nicht gültig:', abonnement);
            }
        },

        update() {
            let promisses = [];

            if (this.abonnements.data.length > 0) {
                promisses.push(this.updateAbonnements());
            }

            promisses.push(this.updateUser());

            Promise.all(promisses)
                .then(() => {
                    this.$toast.success(i18next.t('msg_email_settings_succesfully_updated'));
                    this.loading = false;
                })
                .catch(() => {
                    this.$toast.error(i18next.t('msg_email_settings_update_error'));
                    this.loading = false;
                });
        },
        async updateUser() {
            this.loading = true;
            this.user.email_confirmation = this.user.email;
            return await this.$store.dispatch('user/update', this.user);
        },
        async updateAbonnements() {
            this.loading = true;
            //update all abonnements with id mentioned in idsToUpdate
            for (let index in this.idsToUpdate) {
                let id = this.idsToUpdate[index];
                let abonnement = this.abonnements.data.find((abonnement) => abonnement.id === id);
                await this.$store.dispatch('abonnement/update', abonnement);
            }
            //clear idsToUpdate
            this.idsToUpdate = [];

            return Promise.resolve();
        }
    }
};
</script>
